// -----------存入内存--------------------------
function Setitem(name, content) {
  // 此处写数据库调用
  localStorage.setItem(name, JSON.stringify(content));
}
// -----------存入内存--------------------------

function Getitem(name) {
  // 此处写数据库调用

  return JSON.parse(localStorage.getItem(name));
}

export { Setitem, Getitem };

